













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TaskFilterTab extends Vue {
  @Prop({ default: [] }) private tabList!: object[];
  private selectTab: string = "0";

  private handleSelect(value) {
    this.selectTab = value;
    this.$emit("tabs", value);
  }

  public reSet() {
    this.selectTab = null;
  }
}
